import { render } from "./Estudai.vue?vue&type=template&id=83eae556"
import script from "./Estudai.vue?vue&type=script&lang=js"
export * from "./Estudai.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__